import { useState } from 'react';
import { RotateCcw, Loader2 } from 'lucide-react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../../components/ui/alert-dialog';
import { useTranslation, useI18nStore } from '../../lib/i18n';
const tt = (k, p) => useI18nStore.getState().t(`startStopAdmin.${k}`, p);


export function ResetButton({ r, onConfirm, busy }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} disabled={busy} title={tt('resetTitle')} aria-label={tt('resetTitle')}
        className="ml-auto h-8 w-8 inline-flex items-center justify-center rounded-full border border-rose-200 text-rose-600 hover:bg-rose-50 transition-colors disabled:opacity-50" data-testid={`ss-reset-${r.assignment_id}`}>
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <RotateCcw className="h-4 w-4" />}
      </button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid="ss-reset-confirm-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>{tt('resetConfirmTitle')}</AlertDialogTitle>
            <AlertDialogDescription>
              <b>{r.employee_name}</b> · {r.route_code || '—'} · {r.date}<br />
              {tt('resetConfirmBody')}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="ss-reset-cancel">{tt('cancel')}</AlertDialogCancel>
            <AlertDialogAction onClick={() => { setOpen(false); onConfirm(r); }} className="bg-rose-600 hover:bg-rose-700" data-testid="ss-reset-confirm">{tt('resetYes')}</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
